module.exports = __webpack_public_path__ + "static/3-fb8167b76a8c064dc8a35a5b3584513b.jpg";